import React, { useState } from 'react';
import { Container, Typography, List, ListItem, ListItemText, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const questions = [
  { id: 1, question: "비용은 어떻게 되나요?", answer: "비용은 재매칭 시 부과되며 신청자가 20대일 경우 9,900원, 30대 부터 13,900원의 비용이 부과됩니다." },
  { id: 2, question: "매칭은 어떻게 진행되나요?", answer: "같은 지역과 유사한 나이를 우선으로 AI가 닮은 정도를 분석하여 추천해드리며 신청 정보에서 확인 할 수 있습니다." },
  { id: 3, question: "매칭이 안되는 이유는 무엇인가요?", answer: "매칭 시스템 분석결과 적당한 이성이 없을 경우 매칭이 안될 수 있습니다." },
  { id: 4, question: "매칭 연락은 어떻게 받나요?", answer: "상대방 모두 가입 시 등록하신 연락처로 SMS가 전송됩니다." },
  { id: 5, question: "추천인 코드는 어디에 사용되나요?", answer: "추후 재매칭 시 무료 이용권으로 사용하실 수 있습니다." },
  // Add more questions here
];

const QnaPage = () => {
  const [open, setOpen] = useState(null);

  const handleClick = (id) => {
    setOpen(open === id ? null : id);
  };

  return (
    <Container sx={{ paddingY: 4 }}>
      <Typography variant="h4" gutterBottom>
        QnA
      </Typography>
      <List component="nav">
        {questions.map((q) => (
          <div key={q.id}>
            <ListItem button onClick={() => handleClick(q.id)}>
              <ListItemText primary={q.question} />
              {open === q.id ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open === q.id} timeout="auto" unmountOnExit>
              <Typography variant="body1" style={{ paddingLeft: '30px', paddingBottom: '8px' }}>
                {q.answer}
              </Typography>
            </Collapse>
          </div>
        ))}
      </List>
    </Container>
  );
};

export default QnaPage;
